//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import db from "@/components/firebaseInit";
export default {
  props: ["data"],
  methods: {
    deteteBio: function deteteBio() {
      console.log(this);

      if (confirm("Are you sure?")) {
        db.collection("biography").doc(this.data.id).get().then(function (querySnapshop) {
          querySnapshop.ref.delete(); //   this.$router.push("/app/biography/");
        });
      }
    }
  }
};